import Chip from '@mui/material/Chip';
import { capitalize } from 'lodash';
import { useMemo } from 'react';

import {
  RULES_BLUE,
  RULES_PURPLE
} from '@/pages/Administration/AdministrationRules/AdministrationRules.constants';

const RulesLevelChip = ({ level }: { level: string }) => {
  const color = useMemo(() => {
    if (level === 'global') {
      return RULES_BLUE;
    }
    return RULES_PURPLE;
  }, [level]);

  return (
    <Chip
      label={capitalize(level)}
      variant="outlined"
      sx={{ color, border: `1px solid ${color}` }}
    />
  );
};

export default RulesLevelChip;
